export const draperiesSelect = {
  en: [
    { value: "I Have 25mm Rod", label: "25mm Rod" },
    { value: "I Have 28mm Rod", label: "28mm Rod" },
    { value: "I Have Standard Track", label: "Standard Track", disabled: true },
    { value: "I Have Track With Cord Draw", label: "Track With Cord Draw", disabled: true },
    { value: "I Have Motorized Track", label: "Motorized Track", disabled: true },
    { value: "I Have Others", label: "Others" },
  ],
  fa: [
    { value: "I Have 25mm Rod", label: "میله پردهِ ۲۵ میلیمتری" },
    { value: "I Have 28mm Rod", label: "میله پردهِ ۲۸ میلیمتری" },
    { value: "I Have Standard Track", label: "ریل استاندارد", disabled: true },
    { value: "I Have Track With Cord Draw", label: "ریل اتوماتیک", disabled: true },
    { value: "I Have Motorized Track", label: "موتور برقی", disabled: true },
    { value: "I Have Others", label: "سایر" },
  ],
};

export const sheersSelect = {
  en: [
    { num: "1", value: "I Have 25mm Rod", label: "25mm Rod" },
    { num: "2", value: "I Have 28mm Rod", label: "28mm Rod" },
    { num: "3", value: "I Have Standard Track", label: "Standard Track", disabled: true },
    {
      num: "4",
      value: "I Have Track With Cord Draw",
      label: "Track With Cord Draw",
      disabled: true,
    },
    { num: "5", value: "I Have Motorized Track", label: "Motorized Track", disabled: true },
    { num: "6", value: "I Have Others", label: "Others" },
  ],
  fa: [
    { num: "1", value: "I Have 25mm Rod", label: "میله پردهِ ۲۵ میلیمتری" },
    { num: "2", value: "I Have 28mm Rod", label: "میله پردهِ ۲۸ میلیمتری" },
    { num: "3", value: "I Have Standard Track", label: "ریل استاندارد", disabled: true },
    { num: "4", value: "I Have Track With Cord Draw", label: "ریل اتوماتیک", disabled: true },
    { num: "5", value: "I Have Motorized Track", label: "موتور برقی", disabled: true },
    { num: "6", value: "I Have Others", label: "سایر" },
  ],
};

export const sheersSelect2 = {
  en: [
    { num: "1", value: "I Have 25mm Rod", label: "25mm Rod", disabled: true },
    { num: "2", value: "I Have 28mm Rod", label: "28mm Rod", disabled: true },
    { num: "3", value: "I Have Standard Track", label: "Standard Track" },
    { num: "4", value: "I Have Track With Cord Draw", label: "Track With Cord Draw" },
    { num: "5", value: "I Have Motorized Track", label: "Motorized Track" },
    { num: "6", value: "I Have Others", label: "Others" },
  ],
  fa: [
    { num: "1", value: "I Have 25mm Rod", label: "میله پردهِ ۲۵ میلیمتری", disabled: true },
    { num: "2", value: "I Have 28mm Rod", label: "میله پردهِ ۲۸ میلیمتری", disabled: true },
    { num: "3", value: "I Have Standard Track", label: "ریل استاندارد" },
    { num: "4", value: "I Have Track With Cord Draw", label: "ریل اتوماتیک" },
    { num: "5", value: "I Have Motorized Track", label: "موتور برقی" },
    { num: "6", value: "I Have Others", label: "سایر" },
  ],
};

export const sheersSelect3 = {
  en: [
    { num: "1", value: "I Have 25mm Rod", label: "25mm Rod" },
    { num: "2", value: "I Have 28mm Rod", label: "28mm Rod" },
    { num: "3", value: "I Have Standard Track", label: "Standard Track" },
    { num: "4", value: "I Have Track With Cord Draw", label: "Track With Cord Draw" },
    { num: "5", value: "I Have Motorized Track", label: "Motorized Track" },
    { num: "6", value: "I Have Others", label: "Others" },
  ],
  fa: [
    { num: "1", value: "I Have 25mm Rod", label: "میله پردهِ ۲۵ میلیمتری" },
    { num: "2", value: "I Have 28mm Rod", label: "میله پردهِ ۲۸ میلیمتری" },
    { num: "3", value: "I Have Standard Track", label: "ریل استاندارد" },
    { num: "4", value: "I Have Track With Cord Draw", label: "ریل اتوماتیک" },
    { num: "5", value: "I Have Motorized Track", label: "موتور برقی" },
    { num: "6", value: "I Have Others", label: "سایر" },
  ],
};
